import { useMemo } from 'react';
import { useConfig } from '@browsing/config';
import { isPlusEnabled, isPlusSignupEnabled } from '../utils';
export var usePlusFeature = function () {
    var config = useConfig();
    return useMemo(function () {
        var isEnabled = isPlusEnabled(config);
        var isSignupEnabled = isPlusSignupEnabled(config);
        return { isEnabled: isEnabled, isSignupEnabled: isSignupEnabled };
    }, [config]);
};
